import { getCurrentUser, signOut } from "../util/amplifyAuth";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Header.css";
import { useScreen } from "../context/ScreenProvider";

function Header() {
    const { isMobile } = useScreen()
    const [scrolled, setScrolled] = useState(false);
    const [user, setUser] = useState(null);
    
    const nav = useNavigate();

    useEffect(() => {
        getCurrentUser()
        .then(user => {
            setUser(user)
        })
        .catch(() => {
            // not authenticated
        })

        const handleScroll = () => {
            if(window.scrollY > 0 && !scrolled) {
                setScrolled(true);
            } else if(window.scrollY == 0) {
                setScrolled(false);
            }
        }

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    return (
         <div className={`header ${scrolled ? "header_scrolled" : ""}`}>
            <h3 onClick={() => {nav("/"); window.scrollTo({ top: 0, behavior: 'smooth' })}}>PrimeMaxing</h3>
            {!isMobile && (
                <nav className="header-nav">
                    <a href="#howitworks">How It Works</a>
                    <Link to="/pricing">Pricing</Link>
                    <a href="#faq">FAQ</a>
                </nav>
            )}
            <div className="account">
                {user ? (
                    <button onClick={() => {
                        nav("/home")
                    }}>Home</button>
                ) : (
                    <>
                        <button onClick={() => {
                            nav("/login")
                        }}>Log in</button>
                        {!isMobile && <button onClick={() => {
                            nav("/signup")
                        }}>Create account</button>}
                    </>
                )}
            </div>
        </div>
    )
}

export default Header;